import { render, staticRenderFns } from "./AddArticle.vue?vue&type=template&id=514fbf6a&scoped=true&"
import script from "./AddArticle.vue?vue&type=script&lang=js&"
export * from "./AddArticle.vue?vue&type=script&lang=js&"
import style0 from "./AddArticle.vue?vue&type=style&index=0&id=514fbf6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514fbf6a",
  null
  
)

export default component.exports